import React from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Outcomes } from './components/Outcomes';
import { CourseAccordion } from './components/CourseAccordion';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('2782582688765590');
  return <div className="w-full bg-white font-sans" data-id="element-0" data-mp="2mmvnx2fq2uf8">
      <Hero data-id="element-1" data-mp="2mjzplczyq3q9" />
      <main data-id="element-2" data-mp="31agnwnhawdix">
        <Problems data-id="element-3" data-mp="31b8gdpflpv4z" />
        <Outcomes data-id="element-4" data-mp="31brz38d2snk2" />
        <CourseAccordion data-id="element-5" data-mp="31c1hoavsjsfq" />
        <Testimonials data-id="element-6" data-mp="31cjjro54x0vk" />
        <Bonuses data-id="element-7" data-mp="2wjgrrkg09zhh" />
        <Offer data-id="element-8" data-mp="2wiyxgtcwlvc7" />
      </main>
      <Footer data-id="element-9" data-mp="2wip54z4dzc3c" />
    </div>;
}